import { Table, Tag, Tooltip, Progress } from "antd";
import DetalleTable from "./DetalleTable";
import { useState } from "react";
import { getDetalleProducto } from "../../../../services/financiero/productosEntregasService";

// 🔥 Helpers
const formatNumber = (value) => {
  if (!value) return "0";
  return Number(value).toLocaleString("es-CO", {
    maximumFractionDigits: 0
  });
};

const formatCurrency = (value) => {
  if (!value) return "$0";
  return `$${Number(value).toLocaleString("es-CO", {
    maximumFractionDigits: 0
  })}`;
};

export default function ProductosTable({ data }) {
  const [detalles, setDetalles] = useState({});

  // 🔥 CLAVE ÚNICA (IMPORTANTE)
  const getKey = (r) =>
    `${r.Numero_PO}_${r.oid_municipio}_${r.oid_proyecto}_${r.observacion}`;

  // 🔥 EXPAND
  const handleExpand = async (expanded, record) => {
    const key = getKey(record);

    // 🔥 VALIDACIÓN CORRECTA
    if (
      !record.Numero_PO ||
      record.Numero_PO === "Sin PO" ||
      record.oid_municipio == null ||
      record.oid_proyecto == null
    ) {
      console.warn("Registro sin detalle válido:", record);
      return;
    }

    if (expanded && !detalles[key]) {
      try {
        const res = await getDetalleProducto({
          Numero_PO: record.Numero_PO,
          oid_municipio: record.oid_municipio,
          oid_proyecto: record.oid_proyecto,
          observacion: record.observacion
        });

        setDetalles(prev => ({
          ...prev,
          [key]: res
        }));
      } catch (error) {
        console.error("Error cargando detalle:", error);
      }
    }
  };

  const columns = [
    {
      title: "PO",
      dataIndex: "Numero_PO",
      width: 120
    },
    {
      title: "Municipio",
      dataIndex: "municipio",
      width: 160
    },
    {
      title: "Proyecto",
      dataIndex: "nombre_proyecto",
      width: 280,
      render: (text) => (
        <Tooltip title={text}>
          <div
            style={{
              maxWidth: 260,
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: "1.2em"
            }}
          >
            {text}
          </div>
        </Tooltip>
      )
    },
    {
      title: "Cantidad",
      dataIndex: "cantidad_total",
      width: 120,
      render: formatNumber
    },
    {
      title: "Valor Total",
      dataIndex: "valor_total",
      width: 160,
      render: (v) => (
        <span style={{ fontWeight: 600 }}>
          {formatCurrency(v)}
        </span>
      )
    },
    {
      title: "Entregado",
      dataIndex: "cantidad_entregada",
      width: 130,
      render: formatNumber
    },
    {
      title: "Pendiente",
      dataIndex: "pendiente",
      width: 130,
      render: formatNumber
    },
    {
      title: "% Entrega",
      width: 180,
      render: (_, r) => {
        const percent = Number(r.porcentaje_entrega) || 0;

        return (
          <Progress
            percent={percent}
            size="small"
            status={
              percent === 100
                ? "success"
                : percent === 0
                  ? "exception"
                  : "active"
            }
          />
        );
      }
    },
    {
      title: "Estado",
      width: 140,
      render: (_, r) => {
        const p = Number(r.porcentaje_entrega) || 0;

        if (p === 100) return <Tag color="green">Entregado</Tag>;
        if (p === 0) return <Tag color="red">Sin entregas</Tag>;
        return <Tag color="orange">Parcial</Tag>;
      }
    }
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      rowKey={(r) => getKey(r)}
      scroll={{ x: 1100 }}
      expandable={{
        expandedRowRender: (record) => {
          const key = getKey(record);
          return <DetalleTable data={detalles[key] || []} />;
        },
        onExpand: handleExpand,

        rowExpandable: (record) =>
          record.Numero_PO &&
          record.Numero_PO !== "Sin PO" &&
          record.oid_municipio != null &&
          record.oid_proyecto != null
      }}
    />
  );
}